export const ApplicationRoutes = {
  account: {
    userProfileManagement: '/user-profile-management',
    companyProfile: '/company-profile',
    login: '/login',
    twoFactorLogin: '/two-factor',
    logout: '/logout',
    resetPassword: '/reset-password',
    confirmEmail: '/confirm-email',
    forgotPassword: '/forgot-password',
    reportingRequirementEdit: '/update-requirements/:token'
  },
  booking: {
    hotelSearchLanding: '/hotel-search',
    hotelSearchResults: '/hotel-search-results',
    bookingReport: '/booking-report',
    booking: '/booking',
    bookingMultiple: '/booking-multiple',
    bookingSummary: '/booking-summary',
    bookingFailure: '/booking-failure',
    bookingApprovalRequired: '/booking-approval-required',
    manageBookings: '/manage-bookings'
  },
  approval: {
    info: '/approval/:externalId'
  }
};
